module.exports = __webpack_public_path__ + "img/window-contact-md.07d93f66.svg";